<template>

    <nav class="cf-menutop" ref="menuroot">
        <div class="cf-menu-inner">

            <!-- Bascule mobile -->
            <button @click="toggleNavbar" type="button" class="cf-menu-burger" :aria-expanded="isNavbarOpen.toString()">
                <span class="sr-only">Ouvrir le menu</span>
                <i class="ri-menu-line"></i>
            </button>

            <div :class="{ 'hidden': !isNavbarOpen, 'block': isNavbarOpen }" class="cf-menu-collapse" id="navbar-dropdown">
                <ul class="cf-menu-list">

                    <!-- Liste des articles -->
                    <li v-permission="'stock.produits'">
                        <button type="button" class="cf-menu-btn" @click="btnmodalindexarticle(); openMenu = null; isNavbarOpen = false">
                            <i class="ri-list-check-2 cf-menu-icon"></i> Liste des articles
                        </button>
                    </li>

                    <!-- Fiche technique -->
                    <li v-permission="'stock.fichetechnique'" class="cf-menu-dd">
                        <button type="button" class="cf-menu-btn" :class="{ 'cf-menu-btn--on': openMenu === 'ft' }" @click="toggleMenu('ft')">
                            <i class="ri-file-list-3-line cf-menu-icon"></i> Fiche technique
                            <i class="ri-arrow-down-s-line cf-menu-caret" :class="{ 'cf-menu-caret--on': openMenu === 'ft' }"></i>
                        </button>
                        <transition name="cf-menu-fade">
                            <div v-show="openMenu === 'ft'" class="cf-menu-pop">
                                <button type="button" class="cf-menu-item" @click="btnmodalfichetechnique(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-file-text-line"></i> Fiche technique
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalprintfichetechnique(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-printer-line"></i> Imprimer les fiches techniques
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalanalysematieres(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-bar-chart-box-line"></i> Analyse des matières premières
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalreconstitutionstock(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-history-line"></i> Reconstitution du stock d'une matière
                                </button>
                            </div>
                        </transition>
                    </li>

                    <!-- Stock (mouvements) -->
                    <li v-permission="'stock.mouvements'" class="cf-menu-dd">
                        <button type="button" class="cf-menu-btn" :class="{ 'cf-menu-btn--on': openMenu === 'mvt' }" @click="toggleMenu('mvt')">
                            <i class="ri-arrow-left-right-line cf-menu-icon"></i> Stock
                            <i class="ri-arrow-down-s-line cf-menu-caret" :class="{ 'cf-menu-caret--on': openMenu === 'mvt' }"></i>
                        </button>
                        <transition name="cf-menu-fade">
                            <div v-show="openMenu === 'mvt'" class="cf-menu-pop">
                                <button type="button" v-permission="'stock.mouvements.mvt-entree'" class="cf-menu-item" @click="btnmodalmvtstocksansvalidationindex('mvt_entree'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-login-box-line"></i> Mouvement d'entrée
                                </button>
                                <button type="button" v-permission="'stock.mouvements.mvt-sortie'" class="cf-menu-item" @click="btnmodalmvtstocksansvalidationindex('mvt_sortie'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-logout-box-line"></i> Mouvement de sortie
                                </button>
                                <button type="button" v-permission="'stock.mouvements.mvt-inventaire'" class="cf-menu-item" @click="btnmodalmvtstocksansvalidationindex('mvt_d_inventaire'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-clipboard-line"></i> Mouvement d'inventaire
                                </button>
                                <button type="button" v-permission="'stock.mouvements.mvt-transfert'" class="cf-menu-item" @click="btnmodalmvtstocksansvalidationindex('mvt_transfert'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-swap-box-line"></i> Mouvement de transfert
                                </button>
                                <button type="button" class="cf-menu-item cf-menu-item--muted" disabled>
                                    <i class="ri-file-list-2-line"></i> Liste des expressions de besoins
                                </button>
                            </div>
                        </transition>
                    </li>

                    <!-- Rapport (etats) -->
                    <li v-permission="'stock.etats'" class="cf-menu-dd">
                        <button type="button" class="cf-menu-btn" :class="{ 'cf-menu-btn--on': openMenu === 'rap' }" @click="toggleMenu('rap')">
                            <i class="ri-bar-chart-box-line cf-menu-icon"></i> Rapport
                            <i class="ri-arrow-down-s-line cf-menu-caret" :class="{ 'cf-menu-caret--on': openMenu === 'rap' }"></i>
                        </button>
                        <transition name="cf-menu-fade">
                            <div v-show="openMenu === 'rap'" class="cf-menu-pop cf-menu-scroll">
                                <button type="button" class="cf-menu-item" @click="btnmodalhistoriquedocument(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-history-line"></i> Historique des documents de stock
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodaletatdocstock(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-stack-line"></i> Etat du stock des articles
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalrapportetatdestocksuruneperiode(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-calendar-2-line"></i> Etat du stock des articles sur une période
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalrapportmvtdesarticles(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-arrow-left-right-line"></i> Etat des mouvements des articles
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalrapportarticlesparmouvement(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-swap-line"></i> Articles par mouvement de stock
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalrapportfichedepreinventaire(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-clipboard-line"></i> Fiche d'état de pré-inventaire
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalrapportlistedesarticlespapvstock(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-price-tag-3-line"></i> Liste des articles (PA-PV-STOCK)
                                </button>
                                <button type="button" class="cf-menu-item cf-menu-item--muted" disabled>
                                    <i class="ri-file-chart-line"></i> Récapitulatif des entrées et sorties des articles
                                </button>
                                <button type="button" class="cf-menu-item cf-menu-item--muted" disabled>
                                    <i class="ri-store-2-line"></i> Fiche de point de vente (Récapitulatif du stock)
                                </button>
                            </div>
                        </transition>
                    </li>

                </ul>
            </div>
        </div>
    </nav>


    <modalhistoriquedocument ref="modalhistoriquedocument"></modalhistoriquedocument>
    <modalrapportmvtdesarticles ref="modalrapportmvtdesarticles"></modalrapportmvtdesarticles>
    <modalrapportetatdestocksuruneperiode ref="modalrapportetatdestocksuruneperiode"></modalrapportetatdestocksuruneperiode>
    <modaletatdocstock ref="modaletatdocstock"></modaletatdocstock>
    <modalrapportfichedepreinventaire ref="modalrapportfichedepreinventaire"></modalrapportfichedepreinventaire>
    <modalindexarticle ref="modalindexarticle"></modalindexarticle>
    <modalmvtstocksansvalidationindex ref="modalmvtstocksansvalidationindex"></modalmvtstocksansvalidationindex>
    <modalfichetechnique ref="modalfichetechnique"></modalfichetechnique>
    <modalprintfichetechnique ref="modalprintfichetechnique"></modalprintfichetechnique>
    <modalanalysematieres ref="modalanalysematieres"></modalanalysematieres>
    <modalreconstitutionstock ref="modalreconstitutionstock"></modalreconstitutionstock>
    <modalrapportlistedesarticlespapvstock ref="modalrapportlistedesarticlespapvstock"></modalrapportlistedesarticlespapvstock>
    <modalrapportarticlesparmouvement ref="modalrapportarticlesparmouvement"></modalrapportarticlesparmouvement>


</template>


<script>

    import modalindexarticle from "@/components/views/pages/stock/articles/index";
    import modalfichetechnique from "@/components/views/pages/stock/fichetechnique/index";
    import modalprintfichetechnique from "@/components/views/pages/stock/fichetechnique/rapport/modal_printfichetechnique_v2";
    import modalanalysematieres from "@/components/views/pages/stock/fichetechnique/modal_analysematieres";
    import modalreconstitutionstock from "@/components/views/pages/stock/fichetechnique/modal_reconstitutionstock";
    import modalmvtstocksansvalidationindex from "@/components/views/pages/stock/mvtstock/sansvalidation/index";
    import modalhistoriquedocument from "@/components/views/pages/stock/rapport/modal_historiquedocument";
    import modaletatdocstock from "@/components/views/pages/stock/rapport/modal_rapport_etatdustock";
    import modalrapportfichedepreinventaire from "@/components/views/pages/stock/rapport/modal_rapport_fichedepreinventaire";
    import modalrapportmvtdesarticles from "@/components/views/pages/stock/rapport/modal_rapport_mvtdesarticles";
    import modalrapportetatdestocksuruneperiode from "@/components/views/pages/stock/rapport/modal_rapport_etatdestocksuruneperiode";
    import modalrapportlistedesarticlespapvstock from "@/components/views/pages/stock/rapport/modal_rapport_listedesarticlespapvstock";
    import modalrapportarticlesparmouvement from "@/components/views/pages/stock/rapport/modal_rapport_articlesparmouvement";

    export default {
        /* eslint-disable */
        name: "mymenu",
        data() {
            return {
                isNavbarOpen: false,
                isDropdownOpen: true,
                openMenu: null,
            };
        },
        components: {
            modalprintfichetechnique,
            modalanalysematieres,
            modalreconstitutionstock,
            modalfichetechnique,
            modalindexarticle,
            modalmvtstocksansvalidationindex,

            modalhistoriquedocument,
            modaletatdocstock,
            modalrapportfichedepreinventaire,
            modalrapportmvtdesarticles,
            modalrapportetatdestocksuruneperiode,
            modalrapportlistedesarticlespapvstock,
            modalrapportarticlesparmouvement,

        },
        methods: {


            btnmodalprintfichetechnique(){

                let titlemodal="IMPRIMER LES FICHES TECHNIQUES"

                this.$refs.modalprintfichetechnique.show(titlemodal);
            },




            btnmodalrapportetatdestocksuruneperiode(){

                let titlemodal ="ETAT DU STOCK SUR UNE PERIODE"


                this.$refs.modalrapportetatdestocksuruneperiode.show(titlemodal);
            },

            btnmodalrapportmvtdesarticles(){

                let titlemodal ="MOUVEMENT DES ARTICLES"


                this.$refs.modalrapportmvtdesarticles.show(titlemodal);
            },

            btnmodalrapportarticlesparmouvement(){

                let titlemodal ="ARTICLES PAR MOUVEMENT DE STOCK"


                this.$refs.modalrapportarticlesparmouvement.show(titlemodal);
            },


            btnmodaletatdocstock(){

                let titlemodal ="ETAT DU STOCK DES ARTICLES"


                this.$refs.modaletatdocstock.show(titlemodal);
            },

            btnmodalrapportlistedesarticlespapvstock(){

                let titlemodal ="LISTE DES ARTICLES (PA-PV-STOCK)"


                this.$refs.modalrapportlistedesarticlespapvstock.show(titlemodal);
            },

            btnmodalhistoriquedocument(){

                let titlemodal ="Historique des documents de stock"


                this.$refs.modalhistoriquedocument.show(titlemodal);
            },




            btnmodalrapportfichedepreinventaire(){

                let titlemodal ="Fiche de pré inventaire"


                this.$refs.modalrapportfichedepreinventaire.show(titlemodal);
            },


            btnmodalindexarticle(){

                let titlemodal ="Liste des articles"


                this.$refs.modalindexarticle.show(titlemodal);
            },

            btnmodalmvtstocksansvalidationindex(value){

                let titlemodal


                if (value==='mvt_entree'){
                  titlemodal="Liste des  mouvements d'entrée"
                }

                if (value==='mvt_sortie'){
                  titlemodal="Liste des  mouvements de sortie"
                }

                if (value==='mvt_d_inventaire'){
                  titlemodal="Liste des  mouvements d'inventaires"
                }

                if (value==='mvt_transfert'){
                  titlemodal="Liste des  mouvements de transfert"
                }

                if (value==='depreciation'){
                  titlemodal="Liste des dépréciation de stocks"
                }



                this.$refs.modalmvtstocksansvalidationindex.show(titlemodal,value);
            },


            btnmodalanalysematieres(){

                this.$refs.modalanalysematieres.show();
            },

            btnmodalreconstitutionstock(){

                this.$refs.modalreconstitutionstock.show();
            },

            btnmodalfichetechnique(){

                let titlemodal="FICHE TECHNIQUE DES ARTICLES"

                this.$refs.modalfichetechnique.show(titlemodal);
            },



            toggleNavbar() {
                this.isNavbarOpen = !this.isNavbarOpen;
            },
            toggleDropdown() {

                this.isDropdownOpen = !this.isDropdownOpen;

            },

            // Plumbing menus manuels (remplace Preline hs-dropdown)
            toggleMenu(name) {
                this.openMenu = this.openMenu === name ? null : name;
            },
            handleGlobalClick(e) {
                const root = this.$refs.menuroot;
                if (root && !root.contains(e.target)) {
                    this.openMenu = null;
                }
            }
        },

        mounted() {
            document.addEventListener('click', this.handleGlobalClick);
        },

        beforeUnmount() {
            document.removeEventListener('click', this.handleGlobalClick);
        }
    };
</script>

<style scoped>
    /* Charte cf-/ds- : barre de menu du module Stock (light-only) */
    .cf-menutop {
        margin-top: 4% !important;
        background: #fff;
        border: 1px solid rgb(var(--default-border));
        border-radius: var(--cf-radius);
        box-shadow: var(--cf-shadow-sm);
    }
    @media screen and (max-width: 800px) { .cf-menutop { margin-top: 12.5% !important; } }

    .cf-menu-inner {
        display: flex; flex-wrap: wrap; align-items: center; gap: 0.5rem 1rem;
        padding: 0.6rem 1rem; max-width: 1280px; margin: 0 auto;
    }
    .cf-menutop__brand {
        display: inline-flex; align-items: center; gap: 0.5rem;
        font-weight: 700; font-size: 0.95rem; letter-spacing: -0.01em;
        color: rgb(var(--primary)); text-decoration: none;
    }
    .cf-menutop__brand i { font-size: 1.15rem; }

    .cf-menu-burger {
        margin-left: auto; height: 38px; width: 38px; border: 1px solid var(--cf-border);
        border-radius: var(--cf-radius-sm); background: #fff; color: var(--cf-muted);
        display: inline-flex; align-items: center; justify-content: center; font-size: 1.2rem; cursor: pointer;
    }
    .cf-menu-burger:hover { color: rgb(var(--primary)); border-color: rgb(var(--primary) / 0.35); }
    @media (min-width: 768px) { .cf-menu-burger { display: none; } }

    .cf-menu-collapse { width: 100%; }
    @media (min-width: 768px) { .cf-menu-collapse { display: block !important; width: auto; margin-left: auto; } }

    .cf-menu-list {
        display: flex; flex-direction: column; gap: 0.2rem; list-style: none;
        margin: 0.6rem 0 0; padding: 0;
    }
    @media (min-width: 768px) {
        .cf-menu-list { flex-direction: row; align-items: center; justify-content: flex-end; gap: 0.4rem; margin: 0; }
    }

    .cf-menu-dd { position: relative; }

    .cf-menu-btn {
        display: inline-flex; align-items: center; gap: 0.35rem; width: 100%;
        padding: 0.5rem 0.75rem; border-radius: var(--cf-radius-sm);
        font-weight: 600; font-size: 0.85rem; color: var(--cf-ink);
        background: transparent; border: 0; cursor: pointer; text-align: left;
        transition: color 0.18s ease, background-color 0.18s ease;
    }
    @media (min-width: 768px) { .cf-menu-btn { width: auto; } }
    .cf-menu-btn:hover { color: rgb(var(--primary)); background: rgb(var(--primary) / 0.07); }
    .cf-menu-btn--on { color: rgb(var(--primary)); background: rgb(var(--primary) / 0.10); }
    .cf-menu-icon { color: rgb(var(--primary)); font-size: 1rem; }
    .cf-menu-caret { margin-left: auto; font-size: 0.9rem; color: var(--cf-faint); transition: transform 0.18s ease; }
    @media (min-width: 768px) { .cf-menu-caret { margin-left: 0.15rem; } }
    .cf-menu-caret--on { transform: rotate(180deg); color: rgb(var(--primary)); }

    .cf-menu-pop {
        display: flex; flex-direction: column; gap: 1px;
        margin: 0.15rem 0 0.35rem 0.75rem; padding: 0.35rem;
        border-left: 2px solid var(--cf-border);
    }
    @media (min-width: 768px) {
        .cf-menu-pop {
            position: absolute; top: calc(100% + 6px); right: 0; left: auto; z-index: 40;
            min-width: 260px; margin: 0; padding: 0.4rem;
            background: #fff; border: 1px solid var(--cf-border); border-left: 1px solid var(--cf-border);
            border-radius: var(--cf-radius); box-shadow: var(--cf-shadow-md);
        }
    }
    .cf-menu-scroll { max-height: 70vh; overflow-y: auto; }
    @media (min-width: 768px) { .cf-menu-scroll { min-width: 320px; } }

    .cf-menu-item {
        display: flex; align-items: center; gap: 0.5rem; width: 100%;
        padding: 0.5rem 0.65rem; border-radius: var(--cf-radius-sm);
        font-size: 0.82rem; font-weight: 500; color: var(--cf-ink);
        background: transparent; border: 0; cursor: pointer; text-align: left;
        transition: background-color 0.15s ease, color 0.15s ease;
    }
    .cf-menu-item i { color: var(--cf-muted); font-size: 1rem; flex-shrink: 0; }
    .cf-menu-item:hover { background: rgb(var(--primary) / 0.08); color: rgb(var(--primary)); }
    .cf-menu-item:hover i { color: rgb(var(--primary)); }
    .cf-menu-item--muted { color: var(--cf-faint); cursor: not-allowed; }
    .cf-menu-item--muted:hover { background: transparent; color: var(--cf-faint); }
    .cf-menu-item--muted:hover i { color: var(--cf-muted); }

    .cf-menu-fade-enter-active, .cf-menu-fade-leave-active { transition: opacity 0.15s ease, transform 0.15s ease; }
    .cf-menu-fade-enter-from, .cf-menu-fade-leave-to { opacity: 0; transform: translateY(-4px); }

    .sr-only {
        position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px;
        overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0;
    }

    button:focus { outline: 0 !important; }
</style>
